import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../../../utils/api';
import { DEFAULT_FILTERS, resolveCategory } from '../utils/reportHelpers';

const useReportData = ({ deviceInfo, isAuthenticated, summary, activeComponent, filterValues, preloadedData }) => {
    const pre = preloadedData;

    const [reportData, setReportData] = useState(() => {
        if (pre?.report?.item1 && !pre.report.item1[0]?.response) return pre.report.item1;
        return [];
    });
    const [DataAfterFilter, setDataAfterFilter] = useState(() => {
        if (pre?.report?.item1 && !pre.report.item1[0]?.response) {
            return pre.report.item1.filter(item => item.future !== true);
        }
        return [];
    });
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [settingsValues, setSettingsValues] = useState(() => {
        if (pre?.settings?.item1) {
            return pre.settings.item1.reduce((acc, p) => {
                acc[p.parameterName] = p.parameterValue;
                return acc;
            }, {});
        }
        return {};
    });
    const [clearAllFlag, setClearAllFlag] = useState(false);

    useEffect(() => {
        if (!reportData || reportData.length === 0) return;

        if (JSON.stringify(DEFAULT_FILTERS) !== JSON.stringify(filterValues)) {
            const datevaluecolumns = ['reportedToFinance', 'weekending'];

            let baseData = reportData;
            if (filterValues.future === false) {
                baseData = reportData.filter(item => item.future !== true);
            }

            const filteredtablevalues = baseData.filter(item => {
                return Object.keys(filterValues).every(key => {
                    if (key === 'future') return true;
                    if (!filterValues[key]) return true;
                    if (datevaluecolumns.includes(key)) {
                        if (item[key] === null) {
                            return false;
                        }
                        else {
                            const itemDate = item[key].split('T')[0];
                            const filterDate = filterValues[key].split('T')[0];
                            return itemDate === filterDate;
                        }
                    }
                    else if (key === 'cat') {
                        return resolveCategory(item.cat, item.rowHighlightColour, item.credited) === filterValues[key];
                    }
                    else {
                        return item[key] === filterValues[key];
                    }
                });
            });
            setDataAfterFilter(filteredtablevalues);
        }
        else {
            const baseData = reportData.filter(item => item.future !== true);
            setDataAfterFilter(baseData);
        }
    }, [filterValues, reportData]);

    // clearAllFlag handling
    useEffect(() => {
        if (JSON.stringify(DataAfterFilter) === JSON.stringify(reportData)) {
            if (clearAllFlag) {
                setLoading(false);
            }
        }
    }, [DataAfterFilter]);

    async function fetchReportTable() {
        if (deviceInfo !== '' && isAuthenticated) {
            setLoading(true);
            try {
                const res = await authenticatedFetch('/ManagerReport/GetMangerReport', {
                    method: 'POST',
                    body: JSON.stringify({ Deviceinfo: deviceInfo, Summary: summary })
                });
                const result = await res.json();
                if (result.message != null) {
                    setLoading(false);
                    window.alert(result.item2);
                }
                else if (result.item1[0].hasOwnProperty('response')) {
                    setResponseMessage(result.item1[0].response);
                    setLoading(false);
                }
                else {
                    setReportData(result.item1);
                    setDataAfterFilter(result.item1);
                    fetchSettings();
                    setLoading(false);
                }
            }
            catch (ex) {
                console.log(ex);
                setLoading(false);
            }
        }
    }

    async function fetchSettings() {
        try {
            setLoading(true);
            const res = await authenticatedFetch('/ManagerReport/GetsettingsTableParams', {
                method: 'POST',
            });
            const result = await res.json();
            if (result.message != null) {
                setLoading(false);
                window.alert(result.item2);
            }
            else if (result.item1) {
                const paramsObject = result.item1.reduce((obj, item) => {
                    obj[item.parameterName] = item.parameterValue;
                    return obj;
                }, {});
                setSettingsValues(paramsObject);
                setLoading(false);
            }
        }
        catch (ex) {
            console.log(ex);
            setLoading(false);
        }
    }

    const handleDataChange = async (data, restflag) => {
        if (restflag) {
            setClearAllFlag(true);
        }
        setDataAfterFilter(data);
    };

    return {
        reportData,
        setReportData,
        DataAfterFilter,
        setDataAfterFilter,
        loading,
        setLoading,
        responseMessage,
        settingsValues,
        fetchReportTable,
        handleDataChange,
    };
};

export default useReportData;
